import { type StateCreator } from 'zustand';

import { type CanvasTokenNode } from './createCanvasTokenNodeSlice';

export type ChatComposerNodeSlice = {
  nodes: Record<string, CanvasTokenNode>;
  addNode: (id: string, node: CanvasTokenNode) => void;
  removeNode: (id: string) => void;
};

export type CreateChatComposerNodeSlice = () => StateCreator<ChatComposerNodeSlice, [], [], ChatComposerNodeSlice>;

export const createChatComposerNodeSlice: CreateChatComposerNodeSlice = () => (set) => ({
  addNode: (id, node) => {
    set((state) => ({ nodes: { ...state.nodes, [id]: node } }));
  },
  nodes: {},
  removeNode: (id) => {
    set((state) => {
      if (!(id in state.nodes)) {
        return state;
      }
      const { [id]: _, ...rest } = state.nodes;

      return { nodes: rest };
    });
  },
});
